export const reviewStepStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		width: '100%'
	},

	noChangesText: {
		p: 2,
		color: 'text.secondary',
		fontStyle: 'italic'
	},

	rows: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2
	},

	row: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5
	},

	label: {
		fontSize: '0.75rem',
		fontWeight: 500,
		color: '#9CA3AF',
		textTransform: 'uppercase',
		letterSpacing: '0.05em'
	},

	value: {
		fontSize: '0.875rem',
		fontWeight: 500,
		color: 'text.primary',
		whiteSpace: 'pre-line'
	},

	collection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	item: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1.5,
		pl: 1.5,
		borderLeft: '2px solid var(--mui-palette-divider)'
	},

	itemTitle: {
		fontSize: '0.875rem',
		fontWeight: 700,
		color: 'text.primary'
	},

	attachmentsSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1,
		mb: 3
	},

	sectionTitle: {
		fontSize: '1.25rem',
		fontWeight: 700,
		color: 'text.primary'
	}
};
